import type { FC } from "react"
import React, { useEffect } from "react"
import { Button, Icon, useClipboard } from "@chakra-ui/react"

import type { AccountId } from "query/graphql"
import { useToast } from "common/hooks/useToast"
import { Copy } from "ui/components/icons/font-awesome/Copy"

type Props = {
  treasuryAddress: AccountId
}

const GovernanceTreasuryContractLabel: FC<Props> = ({ treasuryAddress }) => {
  const { onCopy, setValue } = useClipboard(treasuryAddress)
  const { toast } = useToast()

  const renderSuccessToast = (): void => {
    toast({
      status: "success",
      title: "Copied address",
    })
  }

  const handleCopyClick = (): void => {
    onCopy()
    renderSuccessToast()
  }

  useEffect(() => {
    setValue(treasuryAddress)
  }, [setValue, treasuryAddress])

  return (
    <Button
      variant="secondary"
      width={{ base: "100%", sm: "auto" }}
      onClick={handleCopyClick}
    >
      <Icon as={Copy} fill="gray.500" h={4} mr={2} w={4} /> Copy Contract
      Address
    </Button>
  )
}

export default GovernanceTreasuryContractLabel
